import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums';

const GetShippingCompanyCostForDesi = (params?: {
    ShippingCompanyId?: number;
    StartDate?: string;
    EndDate?: string;
}) => {
    const base = ApiURL.Query.GetShippingCompanyCostForDesi;
    const url =
        params && params.ShippingCompanyId
            ? `${base}?ShippingCompanyId=${params.ShippingCompanyId}&StartDate=${params.StartDate}&EndDate=${params.EndDate}`
            : base;
    return request({
        url,
        method: RequestType.GET,
    });
};

const GetSellerShipmentCosts = (params?: { ShippingCompanyId?: number; pageNumber?: number; pageSize?: number }) => {
    const base = ApiURL.Query.GetSellerShipmentCosts;
    const queryParams = new URLSearchParams();
    if (params?.ShippingCompanyId) queryParams.append('ShippingCompanyId', params.ShippingCompanyId.toString());

    // Server pagination
    if (params?.pageNumber) queryParams.append('pageNumber', params.pageNumber.toString());
    if (params?.pageSize) queryParams.append('pageSize', params.pageSize.toString());

    const qs = queryParams.toString();
    const url = qs ? `${base}?${qs}` : base;
    return request({
        url,
        method: RequestType.GET,
    });
};

const ShippingQuery = {
    GetShippingCompanyCostForDesi,
    GetSellerShipmentCosts,
};

export default ShippingQuery;
